"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultKeys = {
  LOGIN_LOCATION: 'login_location',
  USER_ID: 'user_id',
  ACCESS_TOKEN: 'access_token',
  EXPIRES_AT: 'expires_at',
  NONCE: 'auth_nonce',
  STATE: 'auth_state'
};

var isNumber = function isNumber(val) {
  return typeof val === 'number';
};

var stringOrUndefined = function stringOrUndefined(val) {
  return val ? val : undefined;
};

function makeAuthStorage(_a) {
  var _b = _a.storage,
      storage = _b === void 0 ? localStorage : _b,
      _c = _a.keys,
      keys = _c === void 0 ? exports.defaultKeys : _c;
  var LOGIN_LOCATION = keys.LOGIN_LOCATION,
      USER_ID = keys.USER_ID,
      ACCESS_TOKEN = keys.ACCESS_TOKEN,
      EXPIRES_AT = keys.EXPIRES_AT,
      NONCE = keys.NONCE,
      STATE = keys.STATE;
  return {
    retrieveLoginLocation: function retrieveLoginLocation() {
      return stringOrUndefined(storage.getItem(LOGIN_LOCATION));
    },
    storeLoginLocation: function storeLoginLocation(loginLocation) {
      return storage.setItem(LOGIN_LOCATION, loginLocation);
    },
    removeLoginLocation: function removeLoginLocation() {
      return storage.removeItem(LOGIN_LOCATION);
    },
    retrieveUserId: function retrieveUserId() {
      return stringOrUndefined(storage.getItem(USER_ID));
    },
    storeUserId: function storeUserId(userId) {
      return storage.setItem(USER_ID, userId);
    },
    removeUserId: function removeUserId() {
      return storage.removeItem(USER_ID);
    },
    retrieveAccessToken: function retrieveAccessToken() {
      return stringOrUndefined(storage.getItem(ACCESS_TOKEN));
    },
    storeAccessToken: function storeAccessToken(token) {
      return storage.setItem(ACCESS_TOKEN, token);
    },
    removeAccessToken: function removeAccessToken() {
      return storage.removeItem(ACCESS_TOKEN);
    },
    retrieveNonce: function retrieveNonce() {
      var val = storage.getItem(NONCE);
      return val ? Number.parseInt(val) : undefined;
    },
    retrieveExpiresAt: function retrieveExpiresAt() {
      var val = storage.getItem(EXPIRES_AT);
      return val ? Number.parseInt(val) : undefined;
    },
    storeExpiresAt: function storeExpiresAt(expiresAt) {
      return storage.setItem(EXPIRES_AT, expiresAt);
    },
    removeExpiresAt: function removeExpiresAt() {
      return storage.removeItem(EXPIRES_AT);
    },
    storeNonce: function storeNonce(nonce) {
      return storage.setItem(NONCE, nonce);
    },
    removeNonce: function removeNonce() {
      return storage.removeItem(NONCE);
    },
    retrieveState: function retrieveState() {
      return stringOrUndefined(storage.getItem(STATE));
    },
    storeState: function storeState(state) {
      return storage.setItem(STATE, state);
    },
    removeState: function removeState() {
      return storage.removeItem(STATE);
    }
  };
}

exports.makeAuthStorage = makeAuthStorage;